import Vue from 'vue'
export default new Vue({
    data:{
        userInfo: {},
        userConfig: {},
        history: {},
        wormhole: 0,
        location: null
    }
})